// Context pour les messages système — accessible depuis toute l'app
import React, { createContext, useContext } from 'react';
import useSystemMessages from '../hooks/useSystemMessages';

export const MessageContext = createContext(null);

export const MessageProvider = ({ children }) => {
  const { unreadCount, messages, loading, markAsRead, markAllAsRead, refreshMessages } =
    useSystemMessages();

  return (
    <MessageContext.Provider
      value={{ unreadCount, messages, loading, markAsRead, markAllAsRead, refreshMessages }}
    >
      {children}
    </MessageContext.Provider>
  );
};

/**
 * Hook pour consommer le MessageContext
 * @returns {{ unreadCount: number, messages: Array, loading: boolean, markAsRead: Function, markAllAsRead: Function, refreshMessages: Function }}
 */
export const useMessage = () => {
  const ctx = useContext(MessageContext);
  if (!ctx) {
    // Retourner des valeurs par défaut si utilisé hors du provider (ex: pages publiques)
    return {
      unreadCount: 0,
      messages: [],
      loading: false,
      markAsRead: () => {},
      markAllAsRead: () => {},
      refreshMessages: () => {},
    };
  }
  return ctx;
};
